export default __webpack_public_path__ + "static/media/home.83147e3a.svg";